import React from 'react';

interface FormControlsProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  isSubmitting: boolean;
  isLastStep: boolean;
}

export function FormControls({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  isSubmitting,
  isLastStep
}: FormControlsProps) {
  return (
    <div className="flex justify-between mt-6">
      {currentStep > 1 && (
        <button
          type="button"
          onClick={onPrevious}
          className="px-3 py-1.5 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm"
        >
          Previous
        </button>
      )}
      {!isLastStep ? (
        <button
          type="button"
          onClick={onNext}
          className="ml-auto px-3 py-1.5 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 text-sm"
        >
          Next
        </button>
      ) : (
        <button
          type="submit"
          className={`ml-auto px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm ${
            isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Quote Request'}
        </button>
      )}
    </div>
  );
}